import React from 'react';
import {
  Box,
  Typography,
  Tooltip,
  IconButton
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

interface CardTitleProps {
  title: string;
  tooltip: string;
}

const CardTitle: React.FC<CardTitleProps> = ({ title, tooltip }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
    <Typography variant="h5" component="div">
      {title}
    </Typography>
    <Tooltip title={tooltip} arrow>
      <IconButton size="small" sx={{ ml: 1, p: 0.5 }}>
        <InfoIcon fontSize="small" sx={{ color: 'rgba(0, 0, 0, 0.25)', fontSize: '0.9rem' }} />
      </IconButton>
    </Tooltip>
  </Box>
);

export default CardTitle; 